<template>
  <div class="bidlist">
    <div class="d-flex mb-4">
      <DateFilter @change-date="setDateFilter" @change="applyDateFilter" :value="dateFilter" />
      <!-- <v-btn class="mr-2 btn-icon" outlined @click="showStatusFilter = !showStatusFilter">
        <v-badge dot overlap color="error" offset-x="8" bordered :value="hasStatusFilter">
          <v-icon class="mr-md-1">mdi-filter-outline</v-icon>
        </v-badge>
        <span class="d-none d-md-inline">Фильтры</span>
      </v-btn> -->
    </div>
    <v-data-table
      :mobile-breakpoint="100"
      class="bidlist-table"
      :headers="headers"
      :items="meetingList"
      item-key="id"
      :server-items-length="total"
      :options.sync="options"
      :footer-props="footerProps"
      :no-data-text="noDataText"
    >
      <template #top>
        <v-text-field
          dense
          single-line
          hide-details
          outlined
          v-model="search_query"
          label="Введите..."
          class="mb-4"
          clearable
        ></v-text-field>
      </template>

      <template #item="{item}">
        <tr :class="getRowClass(item.is_own)">
          <td>{{ item.client_city }}</td>
          <td>
            <span>{{ item.client_name }}</span>
            <br v-if="item.inn" />
            <span class="font font--label-light font--color_light" v-if="item.inn"> ИНН: {{ item.inn }} </span>
          </td>
          <td>
            <v-chip
              small
              class="ma-1"
              :text-color="getBankTextColor(item.bank_name)"
              :color="getBankBgColor(item.bank_name)"
              >{{ item.bank_name }}</v-chip
            >
            <v-chip
              v-for="v in stgFiltered(item.stg)"
              :key="v"
              class="ma-1"
              small
              :color="productTypesList[v].bgColor"
              :text-color="productTypesList[v].textColor"
              >{{ productTypesList[v].label }}</v-chip
            >
            <MeetingStatusChip class="ma-1" :value="item.meeting_state" />
          </td>
          <td>
            <span
              >{{ new Date(item.meeting_date).toLocaleDateString() }},
              {{ new Date(item.meeting_date).toLocaleTimeString() }}</span
            >
          </td>
          <td>{{ item.meeting_place }}</td>
          <td>
            <span style="white-space: nowrap">{{ formatPhone(item.person_phone) }}</span>
          </td>
          <td>
            <v-btn :data-value="item.id" text icon @click="getMeetingById(item.id)"
              ><v-icon>mdi-chevron-right</v-icon></v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import MeetingStatusChip from "@/components/meeting/MeetingStatusChip";
import DateFilter from "@/components/common/DateFilter";
import { formatPhone } from "@/utils/helpers";

export default {
  components: {
    MeetingStatusChip,
    DateFilter
  },

  data() {
    return {
      showStatusFilter: false,
      footerProps: {
        itemsPerPageText: "Кол-во на странице:",
        itemsPerPageAllText: "Все",
        pageText: "{0}-{1} из {2}",
        itemsPerPageOptions: [5, 10, 15]
      },
      noDataText: "Список пустой",
      banks: {
        modulbank: {
          bgColor: "primary",
          textColor: "#ffffff"
        },
        hice: {
          bgColor: "black",
          textColor: "#ffffff"
        }
      },
      productTypesList: {
        ACCOPEN: {
          label: "РКО",
          bgColor: "#D4F296",
          textColor: "#5E8C00"
        },
        ACCOPENMAN: {
          label: "РКО",
          bgColor: "#D4F296",
          textColor: "#5E8C00"
        },
        "MERCHANT.IA": {
          label: "ИЭ",
          bgColor: "#FAE6AA",
          textColor: "#B79310"
        },
        MODULKASSA: {
          label: "Касса",
          bgColor: "#F9C1BD",
          textColor: "#A61D1D"
        },
        "MERCHANT.TA": {
          label: "ТЭ",
          bgColor: "#FAE6AA",
          textColor: "#B79310"
        },
        "FNS.REG": {
          label: "Рег",
          bgColor: "#EEEEEE",
          textColor: "#808080"
        },
        "MRPL": {
          label: "Маркетплейс",
          bgColor: "#4971d0",
          textColor: "#FFFFFF",
        },
      }
    };
  },

  computed: {
    ...mapState("meeting", ["total", "meetingList", "statuses"]),
    ...mapGetters("profile", ["canCreateApp", "canLoadApps"]),
    ...mapGetters("meeting", ["dateFilter"]),

    statusList() {
      return [
        {
          label: "Все статусы",
          value: "all"
        },
        // мапим статусы из store
        ...Object.entries(this.statuses).map(([value, item]) => ({ value, label: item.label }))
      ];
    },

    search_query: {
      get() {
        return this.$store.state.meeting.search_query;
      },
      set(value) {
        this.$store.commit("meeting/setSearchQuery", value);
      }
    },

    options: {
      get() {
        return {
          page: this.$store.state.meeting.page,
          itemsPerPage: this.$store.state.meeting.pageSize
        };
      },
      set({ page, itemsPerPage }) {
        this.setPage(page);
        this.setPageSize(itemsPerPage);
      }
    },

    headers() {
      return [
        {
          text: "Город",
          value: "client_city",
          sortable: false
        },
        { text: "Клиент", value: "client_name", sortable: false },

        {
          text: "Банк / Продукт / Статус",
          value: "stg",
          sortable: false
        },
        {
          text: "Дата встречи",
          value: "meeting_date",
          sortable: false
        },
        {
          text: "Место встречи",
          value: "meeting_place",
          sortable: false
        },
        // {
        //   text: "Статус встречи",
        //   value: "meeting_state",
        //   sortable: false
        // },
        { text: "Телефон клиента", value: "person_phone", sortable: false },
        { value: "id", sortable: false }
      ];
    }
  },

  watch: {
    search_query() {
      this.debouncedSearch();
    },

    options: {
      handler() {
        this.getAllMeetings();
      },
      deep: true
    }
  },

  methods: {

    ...mapMutations("meeting", ["setDateFilter", "setStatusFilter", "setPage", "setPageSize"]),
    ...mapActions("meeting", ["getAllMeetings", "getMeetingById"]),
    stgFiltered(stgValue) {
      return stgValue.filter(x => this.productTypesList[x]);
    },
    getRowClass(is_own) {
      return {
        "font-weight-bold": is_own === true,
        "text--disabled": is_own === false
      };
    },
    // closeStatusFilter() {
    //   this.showStatusFilter = false;
    // },
    // shouldCloseFilter() {
    //   return this.showStatusFilter;
    // },
    getBankTextColor(bank) {
      return this.banks[bank] ? this.banks[bank].textColor : "#000000";
    },
    getBankBgColor(bank) {
      return this.banks[bank] ? this.banks[bank].bgColor : "#eeeeee";
    },
    formatPhone(value) {
      return formatPhone(value);
    },

    applyDateFilter({ start, end }) {
      this.setDateFilter({ start, end });
      this.options = { page: 1, itemsPerPage: this.options.itemsPerPage };
      this.getAllMeetings();
    },

    // applyStatusFilter(status) {
    //   this.setStatusFilter(status);
    //   this.options = { page: 1, itemsPerPage: this.options.itemsPerPage };
    //   this.getAllMeetings();
    //   this.closeStatusFilter();
    // },
    // openCurrentClient(id) {
    //   console.log(id)
    // },
    applyUserInputFilter() {
      this.options = { page: 1, itemsPerPage: this.options.itemsPerPage };
      this.getAllMeetings();
    }
  },

  created() {
    this.debouncedSearch = debounce(this.applyUserInputFilter, 500);
  }
};
</script>

<style lang="scss">
.theme--light.v-data-table.bidlist-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #777c87;
}

.v-data-table.bidlist-table > .v-data-table__wrapper > table > thead > tr > th {
  text-transform: uppercase;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.1em;
  font-weight: 400;
  height: auto;
  padding: 12px 16px;
}

.v-data-table.bidlist-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 16px;
}

.v-data-table-header {
  background-color: #f5f5f6;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}
</style>
